export default "__VITE_ASSET__3fffa643__"